export default "__VITE_ASSET__nmAWYgRy__"